import React, { useEffect, useState } from 'react'
import { Spin, Result } from 'antd'
import { CompletedPurchaseOrder } from '../../../types/purchaseOrder'
import { PurchaseOrderDetails } from './PurchaseOrderDetails'
import { PurchaseOrderHeader } from './PurchaseOrderHeader'
import { PurchaseOrderItems } from './PurchaseOrderItems'
import { PurchaseOrderTerms } from './PurchaseOrderTerms'
import { PurchaseOrderTotals } from './PurchaseOrderTotals'
import { Organisation } from '../../../services/ApiContext'

export const PurchaseOrderPage: React.FC = () => {
  const [purchaseOrder, setPurchaseOrder] =
    useState<CompletedPurchaseOrder | null>(null)
  const [organisation, setOrganisation] = useState<Organisation | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const loadDocument = async () => {
      try {
        if (window.pdfData) {
          setPurchaseOrder(window.pdfData.purchaseOrder!)
          setOrganisation(window.pdfData.organisation)
          document.title = `PO-
        ${
          window.pdfData.purchaseOrder!.poNumber
            ? window.pdfData.purchaseOrder!.poNumber + '-'
            : new Date(window.pdfData.purchaseOrder!.date).toLocaleDateString()
        }`
          setLoading(false)
          return
        }
      } catch (err) {
        console.error(err)
        setError(err instanceof Error ? err.message : 'Failed to load document')
      } finally {
        setLoading(false)
      }
    }
    loadDocument()
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spin size="large" />
      </div>
    )
  }

  if (error || !purchaseOrder || !organisation) {
    return (
      <Result
        status="error"
        title="Failed to load purchase order"
        subTitle={error || 'Purchase order not found'}
      />
    )
  }

  return (
    <div className="p-8 max-w-[1200px] mx-auto">
      <PurchaseOrderHeader
        purchaseOrder={purchaseOrder}
        organisation={organisation}
      />
      <PurchaseOrderDetails purchaseOrder={purchaseOrder} />
      <PurchaseOrderItems purchaseOrder={purchaseOrder} />
      <PurchaseOrderTotals purchaseOrder={purchaseOrder} />
      <PurchaseOrderTerms purchaseOrder={purchaseOrder} />
    </div>
  )
}
